import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-cws-header',
    templateUrl: './cws-header.component.html',
    styleUrls: ['./cws-header.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class CwsHeaderComponent {

}
